import React from "react";
import bgImage from "../../assets/Under_construction_img.png";

function Blog() {
  return (
    <section
      id="blog"
      // Removed min-h-[42vh] and vertical centering that grows with zoom.
      // Use fixed responsive padding instead so spacing is stable.
      className="w-full bg-[#080D1B] px-6 py-10 md:py-14 lg:py-16"
    >
      <div className="max-w-6xl w-full mx-auto flex flex-col md:flex-row items-center justify-center gap-8 md:gap-12">
        {/* Left: Image */}
        <div className="flex-shrink-0">
          <img
            className="w-[240px] sm:w-[360px] md:w-[420px] lg:w-[520px] h-auto object-contain"
            alt="Under Construction"
            src={bgImage}
          />
        </div>

        {/* Right: Text */}
        <div className="flex flex-col items-center text-center">
          <h1 className="font-bold text-[#dee3f2] text-5xl sm:text-4xl md:text-5xl leading-tight mb-4">
            This <span className="text-[#2B61DE]">Blog </span>is Under
            <br />
            <span className="block">Construction</span>
          </h1>

          <p className="max-w-md text-[#B1BFE4] text-base sm:text-lg md:text-xl">
            Brilliance yet to come!
          </p>
        </div>
      </div>
    </section>
  );
}

export default Blog;
